import ProductOptionValue, { ProductOptionDisplayType } from '@src/quince-site-common/src/domains/ProductOption'

import ColorOptionWithOptionValue from './colorOption/ColorOption'
import ImageOptionWithOptionValue from './imageOption/ImageOption'
import DeprecatedInputOption from './inputOption/DeprecatedInputOption'
import InputOption from './inputOption/InputOption'
import PackOption from './packOption/PackOption'
import TextOptionWithOptionValue from './textOption/TextOption'

export interface OptionProp {
  optionValue: ProductOptionValue
  isSelected: boolean
  onChange?: (val: string) => void
  addborder?: boolean | null
  className?: string
  isRound?: boolean
  salePrice?: number
  selectionSetId: string
  maxCharacterLimit?: number
  minCharacterLimit?: number
  lastChanceSizes?: (string | undefined)[]
  inputOptionError?: string
  showRedDot?: boolean
}

export const DISPLAY_TYPE_VS_OPTION_RENDERER = {
  [ProductOptionDisplayType.COLOR]: ColorOptionWithOptionValue,
  [ProductOptionDisplayType.TEXT]: TextOptionWithOptionValue,
  [ProductOptionDisplayType.IMAGE]: ImageOptionWithOptionValue,
  [ProductOptionDisplayType.INPUT]: InputOption,
  [ProductOptionDisplayType.DEPRECATED_INPUT]: DeprecatedInputOption,
  [ProductOptionDisplayType.PACK]: PackOption,
}
